/**
 * Headerbar
 *
 *
 * @module kickstarter/Headerbar
 */

"use strict";

import Observer from "conditioner/utils/Observer";

class Header {
    constructor(element, options) {
        this._element = element;
        this._options = options;
        //resizeimages
        window.addEventListener("resize", this.fixGrowableImageBox, false);

        //tooltipalike links should do as mouseover on click (cause iPad and so wont "hover")
        document.body.addEventListener("touchstart", function() {}, false);

        this._initialize();
    }

    _initialize() {
        this._headerHeight = this._element.clientHeight;
        this._beginScrollPosition = window.pageYOffset;
        this._scrollDirection;

        window.addEventListener(
            "scroll",
            this.setHeaderClass.bind(this),
            false
        );
        window.addEventListener(
            "resize",
            this.resetHeaderClass.bind(this),
            false
        );
        this.setHeaderClass();

        this.fixGrowableImageBox();
        this.fixHeroImagesScaling();
        this.fixProductItemBoxAligning();
    }

    getModule() {
        return this;
    }

    setHeaderClass() {
        this._scrollDirection = window.pageYOffset;

        if (window.pageYOffset >= this._headerHeight) {
            if (this._scrollDirection > this._beginScrollPosition) {
                this._element.style.top = -1 * this._headerHeight + "px";
                this._beginScrollPosition = window.pageYOffset;
                Observer.publish(this, "onunsticky", this);
            }
            if (this._scrollDirection < this._beginScrollPosition) {
                this._element.style.top = "";
                this.setSticky();
            }
        } else {
            this.setUnSticky();
        }

        this._beginScrollPosition = window.pageYOffset;
    }

    resetHeaderClass() {
        if (this._element.classList.contains("sticky")) {
            let width = document.querySelector("main").clientWidth;
            this._element.style.width = width + "px";
        }
    }

    setSticky() {
        if (!this._element.classList.contains("sticky")) {
            this._element.classList.add("sticky");
            let width = document.querySelector("main").clientWidth;
            this._element.style.width = width + "px";
            var currPaddTop =
                parseInt(
                    document
                        .querySelector(".wrapper")
                        .style.paddingTop.replace("px", "")
                ) || 0;
            document.querySelector(".wrapper").style.paddingTop =
                Math.round(currPaddTop + this._headerHeight) + "px";
        }
        Observer.publish(this, "onsticky", this);
    }

    setUnSticky() {
        if (this._element.classList.contains("sticky")) {
            this._element.classList.remove("sticky");
            this._element.style.width = "";
            var currPaddTop =
                parseInt(
                    document
                        .querySelector(".wrapper")
                        .style.paddingTop.replace("px", "")
                ) || 0;
            document.querySelector(".wrapper").style.paddingTop =
                Math.round(currPaddTop - this._headerHeight) + "px";
        }
    }

    fixGrowableImageBox() {
        //FIXME: this if for growing images, probably side-wide, move to good place
        var growPictures = document.getElementsByClassName("picture grow");
        for (var i = 0; i < growPictures.length; i++) {
            growPictures[i].setAttribute(
                "style",
                "height:" +
                    window.getComputedStyle(growPictures[i], null).height
            );
        }
    }

    fixHeroImagesScaling() {
        if (!document.getElementsByClassName("hero-bar page-item")[0])
            return false;
        var heroImage = document
            .getElementsByClassName("hero-bar page-item")[0]
            .getElementsByTagName("img")[0];
        if (
            document
                .getElementsByClassName("hero-bar page-item")[0]
                .getElementsByTagName("source").length == 0
        ) {
            heroImage.removeAttribute("width");
            heroImage.removeAttribute("height");
            heroImage.style.width = "100%";
        }
    }

    fixProductItemBoxAligning() {
        var productItemBoxes = document.querySelectorAll(
            ".product-listing .product-item:not(.product-item--dynamic)"
        );
        var heightHeader = [],
            heightPricing = [],
            heightChecklistContainer = [];

        //determine
        try {
            for (var i = 0; i < productItemBoxes.length; i++) {
                heightHeader.push(
                    parseInt(
                        window
                            .getComputedStyle(
                                document.querySelectorAll(
                                    ".product-listing .product-item .box header"
                                )[i]
                            )
                            .height.replace("px", "")
                    )
                );
                heightPricing.push(
                    parseInt(
                        window
                            .getComputedStyle(
                                document.querySelectorAll(
                                    ".product-listing .product-item .box .pricing"
                                )[i]
                            )
                            .height.replace("px", "")
                    )
                );
                heightChecklistContainer.push(
                    parseInt(
                        window
                            .getComputedStyle(
                                document.querySelectorAll(
                                    ".product-listing .product-item .box .check-list"
                                )[i]
                            )
                            .height.replace("px", "")
                    )
                );
            }

            //set
            for (var j = 0; j < productItemBoxes.length; j++) {
                document
                    .querySelectorAll(
                        ".product-listing .product-item .box header"
                    )
                    [j].setAttribute(
                        "style",
                        "height:" + Math.max.apply(Math, heightHeader) + "px;"
                    );
                document
                    .querySelectorAll(
                        ".product-listing .product-item .box .pricing"
                    )
                    [j].setAttribute(
                        "style",
                        "height:" + Math.max.apply(Math, heightPricing) + "px;"
                    );
                document
                    .querySelectorAll(
                        ".product-listing .product-item .box .check-list"
                    )
                    [j].setAttribute(
                        "style",
                        "height:" +
                            (Math.max.apply(Math, heightChecklistContainer) +
                                15) +
                            "px;"
                    );
            }
        } catch (err) {
            //console.log("Assumed product box to have header, pricing and check-list-container.. it is not vertically aligned now ")
        }
    }
}

export default Header;
